import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=7893004b&scoped=true&"
import script from "./Aside.vue?vue&type=script&setup=true&lang=js&"
export * from "./Aside.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=7893004b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7893004b",
  null
  
)

export default component.exports